export const FAQ = [
  {
    question: '어떻게 사용하나요?',
    answer: '르브레 멀티스틱밤 윗쪽의 뚜껑을 열고 상단 부위를 돌려 내용물이 올라오면 필요한 부위에 수시로 덧발라줍니다.',
  },
  {
    question: '누가 사용하나요?',
    answer: (
      <span>
        우리 아이들은 물론, 간편한 보습, 진정케어가 필요한 누구나 사용가능합니다.
        <br />
        단, 신생아 및 아이들이 먹지 않도록 주의해주세요.
      </span>
    ),
  },
  {
    question: '보관법이 궁금해요!',
    answer: (
      <span>
        매우 부드럽고 순한 제품이므로 직사광선, 높은 온도 등은 피해주세요. 스틱제형의 특성상 45°C 이상의 고온에서는 스웨팅(물방울 맺힘)현상
        및 내용물 흐름 현상이 발생할 수 있습니다.
        <br />
        믿을 수 있는 성분들로 착하게 만든 제품이니만큼 묽어져 제품 모양이 변형되거나 미세 기포가 발생할 수 있고 생산 시점에 따라 색상이
        상이할 수 있습니다. 사용에는 이상이 없으며 시원한 온도의 보관을 권장해 드립니다.
      </span>
    ),
  },
  {
    question: '컬러 제품도 아이들이 사용해도 되나요?',
    answer:
      '르브레 멀티 코코밤은 선명한 발색이 되지만 프랑스 이브비건 인증 제품으로 안심하고 사용하셔도 되며, 아이들과 어른 모두가 함께 사용할 수 있습니다.',
  },
];
